import { EntityPropList } from '@/common/entities/entityProp/EntityPropList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
export const ProgBrandBonaFidePctDetail = () => {
  
  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'entityProps', label: 'Properties', content: <EntityPropList parentEntity="PROG_BRAND_BONA_FIDE_PCT" parentEntityObj={entityObj} />},
  ]

  return (
    <EntityDetail tabSpecs={tabSpecs}/>
  )
}